import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    noOrders: translate({ id: 'globalStyles.orders.noOrders' }),
    orders: translate({ id: 'global.orders' }),
    on: translate({ id: 'global.on' }),
    off: translate({ id: 'global.off' }),
    maximized: translate({ id: 'globalStyles.maximized' }),
  }))

  return api
}
